// extracted by mini-css-extract-plugin
module.exports = {"heading":"features_heading__dOO_r","text":"features_text__QG2zJ","list":"features_list__qRAp1","item":"features_item__2t_w1"};